<!-- Promotion Bar -->
<div class="mob-normal-header" [class.show]="!isSticky">
    <div class="promotion pt-2 mb-0 d-flex text-center justify-content-center align-items-center">
        <p *ngIf="custom_ticker?.show_ticker == 'true'" class="mb-0 d-flex align-items-center" [innerHTML]="custom_ticker?.custom_ticker |sanitizeHtml"></p>
    </div>
    <!-- Mobile Header Main Row with Grid -->
    <div class="row row align-items-center d-md-none ">
        <div class="col-auto mobile-menu-icon px-0" [ngClass]="themeClass('mobile-menu-section1') ">
            <button class="btn p-0 border-0" type="button" data-bs-toggle="offcanvas" data-bs-target="#mobileSidebar">
                 <i class="fa-solid fa-bars"> </i>
            </button>
        </div>
     <div class="col-9 offset-3">
            <div class="d-flex justify-content-between align-items-center pt-3 pt-md-0">
                <div class="mobile-top-logo"  [routerLink]="['/']" [ngClass]="themeClass('mobile-menu-section2') ">
                    <img *ngIf="showLogo" [src]="cdnImagePath + headerdataLogo?.websiteHeader[firstObj + 2]?.mobile_logo" alt="Logo" loading="lazy" class="img-fluid"  />
                </div>
                <div class="d-flex align-items-center ms-2" [ngClass]="themeClass('mobile-menu-section3')">
                    <ul class="list-unstyled mob-icons d-flex align-items-center mb-0 gap-3">
                        <ng-container *ngIf="!chTheme5 && !chTheme7 && !chTheme13 && !chTheme14">
                         <li *ngIf="isSearchByVehicleDisabled" (click)="openVechicleSearchPopup()"><img [src]="cdnImagePath + headerdata[0]?.icon_image" [alt]="headerdata[0]?.menu_name" class="img-fluid"></li>
                         </ng-container>
                        <li (click)="onAccountButton()"><img [src]="cdnImagePath + headerdata[1]?.icon_image" [alt]="headerdata[1]?.menu_name"></li>
                        <li *ngIf="wishItems > 0">
                            <div class="cart-wrapper position-relative" [routerLink]="headerdata[3]?.menu_link">
                                <img [src]="cdnImagePath + headerdata[3]?.icon_image" [alt]="headerdata[3]?.menu_name" class="img-fluid wish-icon" >
                                <span class="position-absolute cart-badge">{{wishItems}}</span>
                            </div>
                        </li>
                        <li>
                            <div class="cart-wrapper position-relative" (click)="openCartOffcanvas()" data-bs-target="#shoppingCartOffcanvas">
                                <img [src]="cdnImagePath + headerdata[4]?.icon_image" [alt]="headerdata[4]?.menu_name" class="img-fluid">
                                <span class="position-absolute cart-badge">{{cartItems
                                    || 0}}</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="col-12 px-0">
            <div class="position-relative search-form mt-3 mb-4" [ngClass]="themeClass('mobile-menu-section6')">
                <app-header-search></app-header-search>
            </div>
        </div>
        <div *ngIf="chTheme7 || chTheme13 || chTheme14" class="mobile-vehicle-btn col-12 px-0">
            <app-shop-by-vehicle></app-shop-by-vehicle>
         </div>
    </div>
</div>

<!-- Sticky mobile header -->
<div class="d-flex align-items-center justify-content-between d-md-none mob-sticky-header" [class.show]="isSticky" [ngClass]="themeClass('mobile-menu-section4')">
    <div class="mobile-menu-icon">
        <button class="btn p-0 border-0 sticky-sidebar" type="button" data-bs-toggle="offcanvas" data-bs-target="#mobileSidebar">
               <i class="fa-solid fa-bars"> </i>
        </button>
    </div>
    <div class="mobile-top-logo"    [routerLink]="'/'" (click)="scrollTop()" [ngClass]="themeClass('mobile-menu-section5')">
        <img *ngIf="showLogo" [src]="cdnImagePath + headerdataLogo?.websiteHeader[firstObj + 2]?.mobile_logo" alt="Logo" loading="lazy" class="img-fluid"/>
    </div>  
    <div class="d-flex align-items-center ms-2 pt-2" [ngClass]="themeClass('mobile-menu-section3')">
        <ul class="list-unstyled mob-icons d-flex align-items-center mb-0 gap-3 pe-1">
                <li id="dropdownMenuButton" class="search-icon" (click)="showSearchBar()" data-toggle="dropdown"><img [src]="cdnImagePath + headerdata[5]?.icon_image" [alt]="headerdata[5]?.menu_name" class="img-fluid" ></li>
                <div class="search-wrapper" *ngIf="showSearch">
                   <app-header-search (showSearch)="showSearch = $event"></app-header-search>
                </div>
            <li>
                <a href="tel:{{contact}}" class="m-0"><img [src]="cdnImagePath + headerdata[6]?.icon_image" [alt]="headerdata[6]?.menu_name" class="img-fluid"></a>
            </li>
            <!-- <li [routerLink]="headerdata[2]?.menu_link"><img [src]="cdnImagePath + headerdata[2]?.icon_image" [alt]="headerdata[2]?.menu_name"></li> -->
            <li (click)="onAccountButton()"><img [src]="cdnImagePath + headerdata[1]?.icon_image" [alt]="headerdata[1]?.menu_name"></li>
            <li *ngIf="wishItems > 0">
                <div class="position-relative" [routerLink]="headerdata[3]?.menu_link">
                    <img [src]="cdnImagePath + headerdata[3]?.icon_image" [alt]="headerdata[3]?.menu_name" class="wish-icon">
                    <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill  badge-cart">{{wishItems}}</span>
                </div>
            </li>
            <li>
                <div class="position-relative" (click)="openCartOffcanvas()" aria-controls="shoppingCartOffcanvas" data-bs-target="#shoppingCartOffcanvas">
                    <img [src]="cdnImagePath + headerdata[4]?.icon_image" [alt]="headerdata[4]?.menu_name">
                    <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill  badge-cart">{{cartItems
                        || 0}}</span>
                </div>
            </li>
        </ul>
    </div>
</div>